angular.module('jv.search.filter-summary.directive', [])
.directive('jvSearchFilterSummary', [
    function() {
        return {
            scope: {
                summaries: '=jvSearchFilterSummary',
                selectedFilters: '='
            },
            link: function(scope) {
                scope.removeFilter = function(summary) {
                    summary.id === 'sourceId' ? scope.selectedFilters[summary.id].ids = [] : scope.selectedFilters[summary.id] = undefined;
                    scope.selectedFilters[summary.id] = undefined;
                };
            },
            templateUrl: 'directives/filter-summary-template.html'
        };
    }
]);